/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { CommonAPI } from '../../../../api/common/responses';
import { TableHeader } from '../../Rooms/TableHeader';
import { ActivityDescription } from './ActivityDescription';
import { TextTableCell } from '@components/Table/TextTableCell';
import { formatIsoTimestampAsLocalDate, formatIsoToLocalTimeWithTimeZone } from '@utils/formatting';

const baseColumnConfig = {
  Cell: TextTableCell,
  Header: TableHeader,
};

export const columnConfigurations = [
  {
    ...baseColumnConfig,
    accessor: (event: CommonAPI.RoomEvent) => formatIsoTimestampAsLocalDate(event.occurredAt),
    id: 'Date',
    width: '10%',
  },
  {
    ...baseColumnConfig,
    accessor: (event: CommonAPI.RoomEvent) => formatIsoToLocalTimeWithTimeZone(event.occurredAt, { withSec: true }),
    id: 'TIME',
    width: '10%',
  },
  {
    ...baseColumnConfig,
    accessor: (event: CommonAPI.RoomEvent) => event.actor,
    id: 'USER',
    width: '20%',
  },
  {
    ...baseColumnConfig,
    accessor: (event: CommonAPI.RoomEvent) => <ActivityDescription event={event} />,
    id: 'DESCRIPTION',
    width: '80%',
  },
];
